const totalStones = 36
const getStone = seed => {
  // console.log('seed:', seed)
  // Map the seed to a stone number between 1 and 36 (inclusive)
  let stone = ((seed - 1) % totalStones) + 1;
  // console.log('stone:', stone)
  return stone;
};
export default getStone;